module.exports = __webpack_public_path__ + "static/media/devices.22d22f45.png";